import React, {Component} from "react";
import {
    Platform,
    StyleSheet,
    TextInput,
    View,
    Animated,
    FlatList,
    ScrollView,
    Dimensions,

    StatusBar,
    TouchableOpacity,
    KeyboardAvoidingView,
    ImageBackground,
    WebView,
    ActivityIndicator, Linking,
    Text,
    Alert
} from "react-native";
import {connect} from "react-redux";
import HMActionBar from "../../../customviews/HMActionBar";
import {moderateScale} from "../../../tools/Scaling";
import Colors from "../../../tools/Colors";
import {typeExport} from "../../../redux/store/type";
import store from "../../../redux/store/index";
import i18n from "../../../I18n/i18n";
import HMTextView from "../../../customviews/HMTextView";
import HMTextInputEfects from "../../../customviews/HMTextInputEfects";
import {AsyngStorageClass} from "../../../tools/AsyngStorageClass";
import * as  NavigationService from "../../../redux/NavigationService";
import HMSelectInput from "../../../customviews/HMSelectInput";
import axios from "axios";
import HMAlert from "../../../customviews/HMAlert";
import {serviceActionSuccess125} from "../../137/splash/action/ActionSplashGetAllData";

let container = null;

class WebServiceScreen extends Component {

    constructor(props) {
        super(props);
        container = this;
        this.state = {
            visible: true,
            scalesPageToFit: true,
            //  inputWebService: '',
            List: [],
            inputWebService: global.UrlWebService125,
            DeviceType: global._Device ? global._Device.value : -1,
            Device: global._Device,
            isLoadingSelectInput: false,
        };

    }

    // async getInputWebService() {
    //     let a = await AsyngStorageClass.getASyng(typeExport._UrlWebService125);
    //     global._Device = await AsyngStorageClass.getASyng(typeExport._DeviceType);
    //
    //     this.setState({
    //         inputWebService: a,
    //         DeviceType: global._Device ? global._Device.value : -1,
    //         Device: global._Device,
    //     })
    //     global.UrlWebService125 = a ? a : typeExport._baseUrl125;
    //
    //     console.log("))))))",global.UrlWebService125,global._Device)
    // }
    getInputWebService() {
        if (global.UrlWebService125)
            this.setState({
                    inputWebService: global.UrlWebService125,

                },

                () => {

                }
            )

        if (global._Device)
            this.setState({
                    DeviceType: global._Device ? global._Device.value : -1,
                    Device: global._Device,
                },

                () => {

                }
            )
    }

    componentWillReceiveProps(propss) {

    }

    showDialogUpdateApp() {
    }

    componentDidMount() {
        this.getInputWebService();

        this.getServer()
    }

    componentWillUnmount() {
        //Tools._RemoveConnectivity()
    }


    render() {
        let noRefresh = this.props.navigation && this.props.route && this.props.route.params && this.props.route.params.noRefresh

        return (


            <KeyboardAvoidingView style={{flex: 1,}} behavior={"padding"}
                                  enabled={Platform.OS === "ios"}>

                <HMActionBar
                    menu={!(this.props.navigation && this.props.route && this.props.route.params && this.props.route.params.menu === false)}
                    props={this.props} statusBarTransparent
                    // text={i18n.t('ListNews.title')}
                    //text={i18n.t('ListNews.title')}
                    //   text={(item.name ? item.name : (item.title ? item.title : ''))}

                    back
                    text={i18n.t('constant.Setting')}

                    headerVisibility more_menu
                    onBackPress={() => this.props.navigation.pop()}

                />
                <View style={{flex: 1}}>

                    {/*<HMTextView type={"bold"}*/}
                    {/*text={i18n.t('constant.EnterWebServiceAddress')}*/}
                    {/*style={{*/}
                    {/*color: Colors.black,*/}
                    {/*// alignSelf: 'center',*/}
                    {/*fontSize: moderateScale(13),*/}
                    {/*marginEnd: moderateScale(10),*/}
                    {/*marginBottom: moderateScale(8),*/}
                    {/*marginTop: moderateScale(8),*/}

                    {/*}}/>*/}
                    <View style={{
                        width: '100%',
                        height: moderateScale(1),
                        //  backgroundColor: Colors.graylight,
                        shadowColor: '#000000',
                        shadowOffset: {
                            width: 0,
                            height: moderateScale(2)
                        },
                        shadowRadius: moderateScale(5),
                        shadowOpacity: 1.0
                    }}/>


                    <HMTextInputEfects
                        onRef={scroll => this["inputinputWebService"] = scroll}
                        refName={"inputWebService"}
                        styleRoot={{alignSelf: 'center', width: "85%",}}

                        type={"CostumeFumi"}
                        value={this.state.inputWebService}

                        label={i18n.t('constant.inputWebService')}
                        onChangeText={text => this.setState({
                            inputWebService: text
                        })}
                        iconClass={"FontAwesomeIcon"}
                        iconName={'phone'}
                        //keyboardType={'number-pad'}
                        // _scroll={this._scroll}

                        // secureTextEntry={true}
                        //   onSubmitEditing={() => this._focusNextField("inputTenantName")}
                        containerStyle={{backgroundColor: "transparent", width: "100%"}}
                        containerInputStyle={{
                            borderWidth: moderateScale(1),

                            borderRadius: moderateScale(10),
                            // overflow: 'hidden',
                            marginVertical: moderateScale(4)
                        }}
                        border={true}

                    />

                    <HMSelectInput
                        styleRoot={{
                            marginTop: moderateScale(8),     marginBottom: moderateScale(14), alignSelf: 'center', width: "85%",
                        }}
                        onValueChange={(value) => {
                            if (value)
                                this.setState({
                                    DeviceType: value
                                })
                        }}
                        //   requestServer={this.state.List.length > 0 ? null : this.getServerEquipmentItem}
                        requestServerRetry={this.getServer}

                        requestServer={this.state.List.length > 0 ? null : this.getServer}

                        //value={this.state.DeviceType >= 0 ? "ghjhj": i18n.t('constant.SelectItem')}
                        value={this.state.DeviceType ? this.state.DeviceType : i18n.t('constant.SelectItem')}
                        index={this.state.Device ? this.state.Device.index : -1}
                        itemSelectInput={this.state.Device}

                        error={this.state.errorSelectInput}
                        loading={this.state.isLoadingSelectInput}
                        text={i18n.t('constant.DeviceType')}
                        options={this.state.List}/>
                    <TouchableOpacity
                        style={{
                            backgroundColor: Colors.colorPrimary,
                            width: "85%",
                            height: moderateScale(40),
                            alignSelf: 'center',
                            alignItems: "center",
                            justifyContent: "center",
                            marginTop: moderateScale(8),
                            borderRadius: moderateScale(6)
                            // borderRadius:moderateScale(2)
                        }}
                        onPress={async () => {

                            let d = this.getDevice();
                            await AsyngStorageClass.setAsyng(typeExport._DeviceType, d);
                            global._Device = d;
                            if (this.state.inputWebService && this.state.inputWebService.length > 0) {
                                await AsyngStorageClass.setAsyng(typeExport._UrlWebService125, this.state.inputWebService);
                                global.UrlWebService125 = this.state.inputWebService;
                                NavigationService.BackTo(1)
                            }
                            else {
                                await AsyngStorageClass.setAsyng(typeExport._UrlWebService125, null);
                                global.UrlWebService125 = typeExport._baseUrl125;
                                // Alert.alert(
                                //     i18n.t('constant.message'),
                                //     i18n.t('constant.ThisFieldCannotBeEmpty'),
                                //     [
                                //         // {text: 'Ask me later', onPress: () => {}},
                                //         // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                                //         {
                                //             text: i18n.t('constant.ok'), onPress: () => {
                                //             }
                                //         },
                                //     ],
                                //     {cancelable: true}
                                // )
                            }
                            this.setState({
                                inputWebService: global.UrlWebService125,
                                DeviceType: d.value,
                                Device: d,
                            })
                            HMAlert(
                                i18n.t('constant.message'),
                                // i18n.t('constant.RequestSuccessfullyRegistered'),
                                "تغییرات با موفقیت انجام شد",
                                [
                                    // {text: 'Ask me later', onPress: () => {}},
                                    // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                                    {
                                        text: i18n.t('constant.ok'), onPress: () => {
                                            if (!noRefresh) {
                                                store.dispatch(serviceActionSuccess125(null));
                                            }
                                        }
                                    },
                                ],
                                {cancelable: false}
                            )

                        }
                        }
                    >
                        <View
                            style={{
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "center"
                            }}>
                            <HMTextView type={"bold"} text={i18n.t('constant.ok')} style={{
                                color: "white",
                                fontSize: moderateScale(13),
                                //marginEnd: moderateScale(10)
                            }}/>

                        </View>
                    </TouchableOpacity>
                </View>
            </KeyboardAvoidingView>

        );
    }

    getServer(func) {

        //   console.log('func', func)
        if (container.state.List.length < 1) {

            let formData = new FormData();
            formData.append('_operation', typeExport._Fire);
            formData.append('mode', "GetVehicles");
            formData.append('lang', i18n.locale);
            formData.append('token', store.getState().reducerSplashGetAllData.token);
            //  formData.append('record', itemParams.RequestID);

            container.requestServer(
                formData, (item) => container.setState({
                    List: item.result && item.result.list && item.result.list.length > 0 ? item.result.list : [],
                }, () => {
                    //alert(item.success)
                    func ? func() : null
                }), null
            );
        }
        else {
        }
    }

    requestServer(formData, func) {
        let name = null
        container.setState({isLoadingSelectInput: true},
            () => {
            });

        axios.post(global.UrlWebService125, formData, {
            headers: {
                "Content-Type": "multipart/form-data; charset=utf-8;",
                // 'Content-Type': 'application/json',
                //  "Authorization": `Basic ${base64.encode(params.username + ':' + params.password)}`
            },
            timeout: typeExport._TIMEOUT,
        })
            .then(async response => {

                // if (this.state.typeMenu === 3 && response.data.success) {
                //     let arr = await AsyngStorageClass.getASyng(global.IdCity + "ListMessageHistoryOperatorFireScreen")
                //
                //     arr = arr ? arr : []
                //     arr.push(this.props.route.params.item)
                //     await AsyngStorageClass.setAsyng(global.IdCity + "ListMessageHistoryOperatorFireScreen", arr)
                //
                //     global.RefreshListOperatorFireApplyScreen = true;
                // }

                if (response.data.success) {

                    func(response.data)
                    container.setState({errorSelectInput: false, isLoadingSelectInput: false,})

                }
                else {
                    container.setState({
                        errorSelectInput: true,
                        isLoadingSelectInput: false,
                    })

                }


            }).catch((e) => {
            container.setState({
                errorSelectInput: true,
                isLoadingSelectInput: false,
            })
            Alert.alert(i18n.t('constant.message'),
                i18n.t('constant.retry'),
                [
                    // {text: 'Ask me later', onPress: () => {}},
                    {
                        text: i18n.t('constant.ok'),
                        onPress: () => {

                        }
                    }
                ])
            console.log("error", e);
        })

    }

    getDevice() {
        global.RefreshListOperatorFireApplyScreen = true;
        let idx = container.state.List.findIndex(obj => obj.value == container.state.DeviceType);
        if (idx !== -1) {
            let r = container.state.List[idx]
            return {label: r.label, value: r.value, index: idx}

        }
        else
            return {label: i18n.t('constant.SelectItem'), value: idx, index: idx}

    }
}

const mapStateToProps = state => {
    return {
        data: state.reducerSplashGetAllData,
        token: state.reducerSplashGetAllData.token,
        DataSplashScreen: state.reducerSplashGetAllData,

    };
};
const styles = StyleSheet.create({
    WebViewStyle: {
        justifyContent: 'center',
        alignItems: 'center',
        flex: 1,
        marginTop: 40,
    },
    ActivityIndicatorStyle: {
        flex: 1,
        justifyContent: 'center',
    },
});
const mapDispatchToProps = dispatch => {
    return {}
};

export default connect(mapStateToProps, mapDispatchToProps)(WebServiceScreen);
